import { render } from "./SamplesDocument.vue?vue&type=template&id=0762fdf6&ts=true"
import script from "./SamplesDocument.vue?vue&type=script&lang=ts"
export * from "./SamplesDocument.vue?vue&type=script&lang=ts"

import "./SamplesDocument.vue?vue&type=style&index=0&id=0762fdf6&lang=scss"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__